var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartPenClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0597 12.0036L19.2847 5.78801C19.4043 5.64229 19.4654 5.45729 19.4562 5.269C19.4469 5.08071 19.368 4.90259 19.2347 4.76929C19.1014 4.63599 18.9232 4.55704 18.7349 4.54779C18.5467 4.53854 18.3617 4.59966 18.2159 4.71926L12.0003 10.9443L5.78469 4.71926C5.63897 4.59966 5.45397 4.53854 5.26568 4.54779C5.07739 4.55704 4.89927 4.63599 4.76597 4.76929C4.63267 4.90259 4.55372 5.08071 4.54447 5.269C4.53522 5.45729 4.59634 5.64229 4.71594 5.78801L10.9409 12.0036L4.71594 18.2193C4.5751 18.3615 4.49609 18.5535 4.49609 18.7536C4.49609 18.9538 4.5751 19.1458 4.71594 19.288C4.85929 19.4266 5.0509 19.5041 5.25031 19.5041C5.44972 19.5041 5.64133 19.4266 5.78469 19.288L12.0003 13.063L18.2159 19.288C18.3593 19.4266 18.5509 19.5041 18.7503 19.5041C18.9497 19.5041 19.1413 19.4266 19.2847 19.288C19.4255 19.1458 19.5045 18.9538 19.5045 18.7536C19.5045 18.5535 19.4255 18.3615 19.2847 18.2193L13.0597 12.0036Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartPenClose);
export default __webpack_public_path__ + "static/media/SmartPenClose.b1cb4ceec9988d99a92232866471d748.svg";
export { ForwardRef as ReactComponent };